import { t } from "i18next";
import notificationsIcon from "../../assets/images/notifications.svg";
import { useEffect, useState } from "react";
import { getNotification, updateNotification } from "../../services/notification";
import { LoadingSpinner } from "../general/loading-spinner";
import { Notification } from "../../interfaces/notification";
import moment from "moment";
import { Link } from "react-router-dom";

export function UserNotifications() {
    const [loaded, setLoaded] = useState(false);
    const [notifications, setNotifications] = useState<any>([]);
    const [showNotifications, setShowNotifications] = useState(false); 

    useEffect(() => {
        // Función para cargar notificaciones
        const loadNotifications = () => {
            getNotification()
                .then(response => {
                    setNotifications(response.data);
                    setLoaded(true);
                })
                .catch(error => {
                    console.log(error);
                });
        };

        // Cargar notificaciones al montar el componente
        loadNotifications();

        // Configurar polling cada 5 minutos (300000 ms)
        const interval = setInterval(() => {
            loadNotifications();
        }, 300000);

        // Limpiar el intervalo al desmontar el componente
        return () => clearInterval(interval);
    }, []);

    const handleShowNotifications = () => {
        setShowNotifications(true);
    }

    const handleCloseNotifications = (event: any) => {
        event.preventDefault();
        setShowNotifications(false);
    }

    const notificationRoute = (referenceType: string, referenceId: number) => {
        let route = '';
        switch (referenceType) {
            case 'program':
                route = '/programs/' + referenceId;
                break;
            case 'program_media':
                route = '/programs/media/' + referenceId;
                break;
        }
        return route;
    }

    const handleMarkAsRead = (event: any) => {
        event.preventDefault();
        const id = event.currentTarget.dataset.id;
        const body = {
            id: id,
            read: 1
        }
        updateNotification(body)
            .then(response => {
                if (response.data.status == 1) {
                    const newNotifications = notifications.filter((n: Notification) => n.id != id);
                    setNotifications(newNotifications);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClickInfo = (event: any) => {
        const id = event.currentTarget.dataset.id;
        const body = {
            id: id,
            read: 1
        }
        updateNotification(body)
            .then(response => {
                if (response.data.status == 1) {
                    const newNotifications = notifications.filter((n: Notification) => n.id != id);
                    setNotifications(newNotifications);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    return (
        <div className="user-notifications-container">
            <div className="notifications-activator">
                <img src={ notificationsIcon } alt={ t("notifications") } onClick={ handleShowNotifications }/>
                {notifications.length > 0 && (
                    <span className="notifications-badge">{notifications.length}</span>
                )}
                <div className="icon-name">{ t("notifications") }</div>
            </div>
            { showNotifications &&
                <div className="notifications-list-container">
                    <a href="#" className="close" onClick={ handleCloseNotifications }></a>
                    <div className="inner">
                        { !loaded && <LoadingSpinner /> }
                        { loaded && notifications.length == 0 &&
                            <div className="notifications-message">
                                { t("There are no new notifications for you.") }
                            </div>
                        }
                        { loaded && notifications.length > 0 &&
                            <div className="notifications-list">
                                { notifications.map((n: Notification) => {
                                    return <div className="notification-item" key={ 'notification-' + n.id }>
                                            <a className="read-flag" data-id={ n.id } title={ t("Mark as read") } onClick={ handleMarkAsRead }></a>
                                            <div className="notification-date">
                                                <i className="bi bi-calendar-check"></i> { moment(n.created_at).format('DD/MM/Y HH:mm') + 'h' }
                                            </div>
                                            <div className="notification-message">
                                                { n.message }
                                            </div>
                                            <div className="actions">
                                                <Link to={ notificationRoute(n.reference_type, n.reference_id) } data-id={ n.id } onClick={ handleClickInfo } target="_blank" rel="noopener noreferrer" title={ t("+ info")}>{ t("+ info")}</Link>
                                            </div>
                                        </div>
                                })}
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    );
}